document.addEventListener("DOMContentLoaded", function () {

  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

  gsap.registerPlugin(ScrollTrigger);

  // Fade from TOP
  gsap.utils.toArray(".fade-top").forEach(el => {
    gsap.from(el, {
      y: -30,
      opacity: 0,
      duration: 0.7,
      ease: "power2.out",
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
        once: true
      }
    });
  });

  // Fade from BOTTOM
  gsap.utils.toArray(".fade-bottom").forEach(el => {
    gsap.from(el, {
      y: 30,
      opacity: 0,
      duration: 0.7,
      ease: "power2.out",
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
        once: true
      }
    });
  });

});

document.addEventListener("DOMContentLoaded", function () {

  if (typeof gsap === "undefined") return;

  const layers = document.querySelectorAll(".layered_banner .layer-item.breathing");

  layers.forEach(layer => {

    // Get the image inside (desktop or mobile, whichever is visible)
    const img = layer.querySelector(".layer-img img");
    if (!img) return;

    // Wait for CSS pop to finish
    layer.addEventListener("animationend", function (e) {

      if (e.animationName !== "layerPop") return;

      startBreathing(img);

    });

  });

  function startBreathing(el) {
    if (el._breathTween) return;

    el._breathTween = gsap.to(el, {
      scale: 1.03,
      y: -6,
      duration: 2.2,
      ease: "sine.inOut",
      yoyo: true,
      repeat: -1
    });
  }

});


